import {styled} from '@mui/material/styles';
import Checkbox, {CheckboxProps} from '@mui/material/Checkbox';
import {Pallete} from '../../theme/bluebird';
import {Tooltip} from '../tooltip/tooltip';

const CustomIcon = styled('span')(() => ({
  borderRadius: '3px',
  width: '12px',
  height: '12px',
  outline: `1px solid ${Pallete.gray.base}`,
  '.Mui-focusVisible &': {
    outline: `1px solid ${Pallete.blue.base}`,
  },
  'input:hover ~ &': {
    outline: `1px solid ${Pallete.blue.base}`,
  },
  'input:disabled ~ &': {
    outline: '1px solid #EAECF0',
    backgroundColor: '#F2F4F7',
  },
}));

const CustomCheckedIcon = styled(CustomIcon)({
  backgrounColor: Pallete.blue.base,
  outline: `1px solid ${Pallete.blue.base}`,
  '&:before': {
    content: '""',
    display: 'block',
    width: '12px',
    height: '12px',
    backgroundColor: Pallete.blue.base,
    backgroundImage:
      "url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath" +
      " fill-rule='evenodd' clip-rule='evenodd' d='M12 5c-.28 0-.53.11-.71.29L7 9.59l-2.29-2.3a1.003 " +
      "1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29s.53-.11.71-.29l5-5A1.003 1.003 0 0012 5z' fill='white'/%3E%3C/svg%3E\")",
  },
  'input:hover ~ &': {
    width: '12px',
    height: '12px',
    backgrounColor: Pallete.blue.base,
  },
});

export type CustomCheckboxProps = CheckboxProps & {
  disabledTooltip?: string;
};

export const CustomCheckbox = ({disabledTooltip, ...rest}: CustomCheckboxProps) => (
  <Tooltip.NotAllowedIf condition={rest.disabled} title={disabledTooltip}>
    <Checkbox
      disableRipple
      checkedIcon={<CustomCheckedIcon />}
      icon={<CustomIcon />}
      {...rest}
      sx={{marginBottom: '0px', ...rest.sx}}
    />
  </Tooltip.NotAllowedIf>
);
